import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";
import { Link } from 'react-router-dom';
import TokenAuth from '../../../Authentication/TokenAuth/TokenAuth';


const Login = () => {
    const { setToken } = TokenAuth()
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const login = async (data) => {
        const user = {
            phone: data.phone,
            password: data.password
        };



        fetch(`${process.env.REACT_APP_SECRET_API}/user-login`, {
            method: "POST",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "content-type": "application/json",
            },
            body: JSON.stringify(user),
        })
            .then((res) => res.json())
            .then((data) => {
                // console.log(data)
                if (data.success === true) {
                    toast.success("Successfully Login");
                    setToken(data.data.access_token);
                    // navigate('/')
                    // localStorage.setItem('phone', phoneData)
                } else {
                    toast.error(data?.message);
                    // console.log(data)
                }
                reset()
            })
    }

    // handle show password icon
    const [toggle1, setToggle1] = useState(false);
    return (
        <div>
            <div className="contain py-16 ">
                <div className="max-w-md bg-white mx-auto shadow px-6 py-7 rounded overflow-hidden">
                    <h2 className="lg:text-2xl text-[20px] uppercase font-medium mb-1 text-center text-black">Login</h2>
                    <p className="text-gray-600 mb-6 text-sm text-center">
                        welcome back customer
                    </p>
                    <div className="divider"></div>
                    <form onSubmit={handleSubmit(login)}>
                        <div className="space-y-2">
                            <div>
                                <label htmlFor="phone" className="text-[#0364BE] text-sm lg:text-[16px] mb-2 block">Your Phone Number</label>
                                <input type="text" name="phone"
                                    className="block w-full border bg-white border-gray-300 px-4 py-2 lg:py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="0123456789"
                                    {...register("phone", {
                                        required: {
                                            value: true,
                                            message: "Number is Required"
                                        },
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: "Only give number."
                                        },
                                        minLength: {
                                            value: 11,
                                            message: "Must be 11 digits"
                                        },
                                        maxLength: {
                                            value: 11,
                                            message: "No more than 11 digits can be given"
                                        }
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.phone?.message}</span>
                            </div>

                            <div>
                                <label htmlFor="phone" className="text-[#0364BE] text-sm lg:text-[16px] mb-2 block">Password</label>

                                {(toggle1 === false) ? <RiEyeOffLine className='text-black cursor-pointer absolute mt-4 ml-[370px]' onClick={() => setToggle1(!toggle1)}></RiEyeOffLine> : <RiEyeLine className='text-red-500 cursor-pointer absolute mt-4 ml-[370px]' onClick={() => setToggle1(!toggle1)}></RiEyeLine>}

                                <input type={toggle1 ? "text" : "password"} name="phone"
                                    className="block w-full border py-2 lg:py-3 bg-white border-gray-300 px-4 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                    placeholder="••••••••"
                                    {...register("password", {
                                        required: {
                                            value: true,
                                            message: "Password is Required"
                                        },

                                        // password pattern off here


                                        // pattern: {
                                        //     value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
                                        //     message: "Minimum six characters, at least one letter and one number"
                                        // },
                                        minLength: {
                                            value: 6,
                                            message: "Must be exceed 6 characters"
                                        },
                                    })}
                                />
                                <span className='text-xs text-red-500 text-left'>{errors.password?.message}</span>
                            </div>
                        </div>
                        <div className="flex items-center justify-between mt-6">
                            <div className="flex items-center">
                            </div>
                            <Link to="/reset-password" className="text-primary text-[14px]">Forget Password</Link>
                        </div>
                        <div className="mt-4">
                            <button type="submit"
                                className="block w-full py-2 text-center text-white bg-gradient-to-r from-primary to-[#52a3eb] border border-primary rounded hover:from-[#52a3eb] hover:to-primary transition uppercase font-roboto font-medium">
                                Login
                            </button>                        
                        </div>
                    </form>
                    <p className="mt-4 text-center lg:text-[14px] text-sm text-gray-600">Don't have account? <Link to="/sign-up"
                        className="text-primary">Register
                        now</Link></p>
                </div>
            </div>
        </div>
    );
};

export default Login;